<!--预付款账户  -->
<template>
	<div>
		<el-dialog title="预付款账户"
		 	:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			width="600px">
			<div class="form-box">
				<el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="80px" size="small">
					<el-form-item label="组织部门" prop="groupName">
						<div class="flex">
							<el-input v-model.trim="dataForm.groupName" maxlength="32" readonly :disabled="dataForm.accountId ? true : false"></el-input>
							<el-button type="primary" size="small" :disabled="dataForm.accountId ?true:false" :style="dataForm.accountId ? 'cursor: not-allowed;' : ''" class="ml20" @click="showGroupTree">配置组织</el-button>
						</div>
					</el-form-item>
					<div class="flex flex-between">
						<el-form-item label="账户名称" prop="accountName">
							<el-input v-model.trim="dataForm.accountName"  maxlength="20"></el-input>
						</el-form-item>

						<el-form-item label="预警额" prop="limitMoney">
							<el-input v-model.trim="dataForm.limitMoney" maxlength="5"></el-input>
						</el-form-item>
					</div>
					<el-form-item label="备注" prop="remark">
						<el-input v-model.trim="dataForm.remark" type="textarea" maxlength="50" :rows="2"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle">取 消</el-button>
				<el-button type="primary" size="small" @click="handleSubmit">确 定</el-button>
			</span>
			<el-dialog
				:visible.sync="groupTreeDialog"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				append-to-body
				width="35%">
				<div class="dialog-input flex flex-middle" slot="title">
					<label class="f14 font-weight-bold mr5">选择组织部门</label>
				</div>
				<div class="mt10">
					<el-input size="small" placeholder="输入搜索内容" v-model="filterText" clearable></el-input>
				</div>
				<el-tree
					ref="tree"
					:data="treeData"
					show-checkbox
					node-key="groupId"
					:check-strictly="true"
					:props="defaultProps"
					:filter-node-method="filterNode"
					:default-expanded-keys="expandedKeys"
					@check="handleCheck"
					class="tree-box mt10">
					<span class="custom-tree-node" slot-scope="{ node, data }">
						<span>
							<i class="el-icon-folder-opened"></i>
							{{ node.label }}
						</span>
					</span>
				</el-tree>
				<div class="flex flex-center mt20">
					<el-button size="small" class="save-btn" type="primary" @click="handleTree()">确定</el-button>
				</div>
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	export default {
		components: {

		},
		data() {
			return {
				dialogVisible: false,
				groupTreeDialog: false,
				treeData: [],
				expandedKeys: [],
				groupName: '',
				filterText: '',
				defaultProps: {
					children: "children",
					label: "groupName"
				},
				dataForm: {
					groupId: '',
					groupName: '',
					accountName: '',
					limitMoney: '',
					remark: ''
				},
				rules: {
					groupName: [
						{
							required: true,
							message: '请选择组织部门',
							trigger: 'blur'
						}
					],
					accountName: [
						{
							required: true,
							message: '请输入账户名称',
							trigger: 'blur'
						}
					],
					limitMoney: [
						{
							required: true,
							message: '请输入预警额',
							trigger: 'blur'
						},
						{
							pattern: /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,2})?$)/,
							message: '请输入整数或者保留三位小数'
						}
					],
				}
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		created() {

		},
		methods: {
			init(dt) {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.dataForm.resetFields();
					this.getTree();
					delete this.dataForm.accountId;
					this.filterText = '';
					this.expandedKeys = [];
					if(this.$refs.tree) {
						this.$refs.tree.setCheckedKeys([]);
					}
					this.dataForm.groupId = '';
					if(dt) {
						this.dataForm.accountId = dt.accountId;
						this.dataForm.groupName = dt.groupName;
						this.dataForm.groupId = dt.groupId;
						this.dataForm.accountName = dt.accountName;
						this.dataForm.limitMoney = dt.limitMoney;
						this.dataForm.remark = dt.remark;
					}
				})
			},
			// 组织树
			showGroupTree() {
				// console.log(this.dataForm.accountId)
				// if(this.dataForm.accountId) {
				// 	return
				// }
				this.groupTreeDialog = true;
				this.$nextTick(() => {
					this.expandedKeys = [this.dataForm.groupId];
					this.$refs.tree.setCheckedKeys([this.dataForm.groupId]);
					// if(this.dataForm.accountId) {
					// 	this.expandedKeys = [this.dataForm.groupId];
					// 	this.$refs.tree.setCheckedKeys([this.dataForm.groupId]);
					// }
				})
			},
			// 获取组织
			getTree() {
				let that = this;
				that.$request.post(
					"tree",
					false, {
						groupType: 1
					}
				)
				.then((res) => {
					if (res) {
						that.treeData = res.data;
						if(!res.data[0].children){
							that.dataForm.groupId = res.data[0].groupId;
							that.dataForm.groupName = res.data[0].groupName;
						}
						
					}
				})
			},
			// 搜索
			filterNode(value, data) {
				if (!value) return true;
				return data.groupName.indexOf(value) !== -1;
			},
			// 单选
			handleCheck(node,nodes) {
				this.$refs.tree.setCheckedKeys([]);
				if(nodes.checkedKeys.length != 0) {
					this.$refs.tree.setCheckedKeys([node.groupId]);
				}
			},
			// 获取组织部门数据
			handleTree() {
				let node = this.$refs.tree.getCheckedNodes()[0];
				this.dataForm.groupId = node.groupId;
				this.dataForm.groupName = node.groupName;
				this.groupTreeDialog = false;
				this.$refs.dataForm.validateField("groupName");
			},
			handleSubmit:debounce(function() {
				if(this.dialogVisible == false) {
					return
				}
				this.$refs['dataForm'].validate(valid => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
						let that = this;
						that.$request.post(
							that.dataForm.accountId ? 'prepaidAccountUpdate' : 'prepaidAccountAdd',
							true, that.dataForm
						)
						.then((res) => {
							that.dialogVisible = false;
							if (res) {
								that.$emit('getList');
								that.$message.success('保存成功');
							}
						})
						}).catch(() => {});
					} else {
						return false;
					}
				});
			},1000,true),
			// 取消
			cancle() {
				this.dialogVisible = false;
				this.$refs['dataForm'].resetFields();
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}
	.el-tree{
		height: 335px;
    	overflow: auto;
	}
</style>
